import { ComponentRef, Directive, ElementRef, Input, ViewContainerRef } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LoaderService } from 'core/services';
import { BehaviorSubject, combineLatest, distinctUntilChanged, filter, map, Subject, takeUntil } from 'rxjs';

@Directive({
  selector: '[libLoaderButton]',

})
export class LoaderButtonDirective {
  readonly #destroy = new Subject<void>()

  readonly keysSubject = new BehaviorSubject<string[]>([])
  @Input() get keys() {
    return this.keysSubject.value
  }
  set keys(value) {
    this.keysSubject.next(value)
  }


  readonly loadersObs = combineLatest([
    this.keysSubject.pipe(filter(Boolean)),
    this._loaderService.loadersSubject
  ])
    .pipe(
      map(([keys, loaders]) => Object.values(loaders).filter(({ key: searchKey }) => keys.includes(searchKey))
      )
    )

  readonly showLoaderObs = this.loadersObs.pipe(map(loaders => Boolean(loaders.length)))

  constructor(
    private readonly _elementRef: ElementRef<HTMLButtonElement>,
    private readonly _viewContainerRef: ViewContainerRef,
    private readonly _loaderService: LoaderService
  ) {


    this.showLoaderObs
      .pipe(distinctUntilChanged(), takeUntil(this.#destroy))
      .subscribe((show) => {
        if (show) {

          this.spinnerRef = this._viewContainerRef.createComponent(MatProgressSpinner);

          this.spinnerRef.instance.diameter = 30;
          this.spinnerRef.instance.strokeWidth = 3.5;
          this.spinnerRef.instance.color = 'primary'
          this.spinnerRef.instance.mode = 'indeterminate'
          this._elementRef.nativeElement.disabled = true;
          this._elementRef.nativeElement.appendChild(this.spinnerRef.location.nativeElement);

          return;
        }

        this._elementRef.nativeElement.disabled = false;
        this.spinnerRef?.destroy();
      })

  }

  spinnerRef: ComponentRef<MatProgressSpinner>


  ngOnDestroy() {
    this.#destroy.next()
    this.#destroy.complete()
  }
}
